import { render } from "./catalogAdd.vue?vue&type=template&id=a4bc674a&scoped=true"
import script from "./catalogAdd.vue?vue&type=script&lang=js"
export * from "./catalogAdd.vue?vue&type=script&lang=js"

import "./catalogAdd.vue?vue&type=style&index=0&id=a4bc674a&scoped=true&lang=css"

import exportComponent from "C:\\projects\\carenvisitorapp\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a4bc674a"]])

export default __exports__